import { Menu } from 'antd';
import styled from 'styled-components';
import { theme } from '../../../theme/semanticTokens';
import type { MenuItemState, MenuItemType } from './types';

export const StyledMenuItem = styled(Menu.Item)<{
  $type: MenuItemType;
  $state: MenuItemState;
  disabled?: boolean;
}>`
  &&&&&& {
    padding: ${theme.dime.spacing.m};
    border-radius: ${theme.dime.radius.s};
    margin: 0 0 4px 0;

    &:last-child {
      margin-bottom: 0;
    }
    height: 32px;
    min-height: 32px;
    min-width: 180px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: ${theme.dime.spacing.m};
    &::before {
      display: none;
    }

    .menu-item-content {
      margin: 0;
      padding: 0;
      display: inline-flex;
      align-items: center;
      justify-content: flex-start;
      vertical-align: middle;
      flex: 0 1 auto;
      min-width: 0;
      line-height: ${theme.dime.fonts.lineHeights.md};
      ${({ $type, $state, disabled }) => {
        if ($state === 'disabled' || disabled) {
          return `
            color: ${theme.dime.colors.text.disabled};
          `;
        }

        switch ($type) {
          case 'destructive':
            return `
              color: ${theme.dime.colors.text.critical};
            `;
          case 'bold':
          case 'default':
          default:
            return `
              color: ${theme.dime.colors.text.primary};
            `;
        }
      }}
    }

    background-color: transparent;

    ${({ $state }) =>
      $state === 'hover' &&
      `
      background-color: ${theme.dime.colors.surface.secondary};
    `}

    ${({ $state }) =>
      $state === 'selected' &&
      `
      background-color: ${theme.dime.colors.surface.primarySelected};
    `}

    ${({ $state }) =>
      $state === 'clicked' &&
      `
      background-color: ${theme.dime.colors.surface.primarySelected};
    `}

    ${({ $state }) =>
      $state === 'disabled' &&
      `
      background-color: transparent;
      cursor: not-allowed;
      opacity: 1;
    `}

    &:hover:not(.ant-menu-item-disabled):not(.ant-menu-item-selected) {
      ${({ $state }) =>
        $state === 'default' &&
        `
        background-color: ${theme.dime.colors.surface.secondary};
      `}
    }

    &.ant-menu-item-selected:not(.ant-menu-item-disabled) {
      ${({ $state }) =>
        $state === 'default' &&
        `
        background-color: ${theme.dime.colors.surface.primarySelected};
      `}
    }

    &.ant-menu-item-disabled {
      background-color: transparent;
      cursor: not-allowed;
      opacity: 1;

      .menu-item-content {
        color: ${theme.dime.colors.text.disabled};
      }
    }
  }
`;

export const MenuItemContent = styled.div<{ $showArrow?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $showArrow }) =>
    $showArrow ? 'space-between' : 'flex-start'};
  gap: ${theme.dime.spacing.m};
  flex: 1 1 100%;
  width: 100%;
  min-width: 0;
`;

export const MenuItemArrow = styled.div<{
  $type: MenuItemType;
  $state: MenuItemState;
}>`
  display: flex;
  align-items: center;
  margin-left: auto;
  flex-shrink: 0;
  flex-grow: 0;
  order: 999;
  color: ${({ $type, $state }) => {
    if ($state === 'disabled') {
      return theme.dime.colors.text.disabled;
    }
    switch ($type) {
      case 'destructive':
        return theme.dime.colors.text.critical;
      default:
        return theme.dime.colors.text.primary;
    }
  }};
`;
